
import { mapActions, mapGetters } from 'vuex'
import LoleBackdrop from '~/components/common/lole-backdrop'
import Button from '~/components/buttons/Button'
import Price from '~/components/price/price'
import LolePicture from '~/components/picture/lole-picture'
import { isProductSellable } from '~/helpers/shopify/product'

export default {
  name: 'LoleWishlistConfirmation',
  components: {
    LoleBackdrop,
    Button,
    Price,
    LolePicture,
  },
  computed: {
    ...mapGetters({
      vxCustomer: 'customer/getCustomer',
      vxWishlistedItem: 'wishlist/getWishlistedItem',
      vxStory: 'common/getCommonWishlistStory',
    }),
  },
  watch: {
    vxWishlistedItem() {
      this.getFocus()
    },
  },
  methods: {
    ...mapActions({
      vxUnsetWishlistedItem: 'wishlist/unsetCurrentWishlistItem',
      vxCloseAllMobile: 'navigation/closeAllMobile',
      vxCloseAllDesktop: 'navigation/closeAllDesktop',
    }),
    goToSignIn() {
      this.closeAll()
      this.$router.push(this.localePath('/signin?wishlist'))
    },
    goToWishlist() {
      this.closeAll()
      this.$router.push(this.localePath('/wishlist'))
    },
    isSellable() {
      return isProductSellable(this.$i18n.locale, this.$config)
    },
    getFocus() {
      if (this.vxWishlistedItem)
        setTimeout(() => {
          this.$refs.closeButton.focus()
        }, 500)
    },
    getCustomAttributeValue(key) {
      const attribute = this.product.customAttributes.find((attribute) => {
        return attribute.key === key
      })
      return attribute ? attribute.value : ''
    },
    closeAll() {
      this.vxUnsetWishlistedItem()
      this.vxCloseAllMobile()
      this.vxCloseAllDesktop()
    },
  },
}
